export default __webpack_public_path__ + "static/media/terra-logo.a9046a6f.png";